<template>
  <div id="app">
    <!-- Start Banner Area -->
	<section class="banner-area relative">
		<div class="container">
			<div class="row d-flex align-items-center justify-content-center">
				<div class="about-content col-lg-12">
					<h1 class="text-white">
						{{this.firstname}}'s Blog
					</h1>
					<p>You'll get to view the blogs posted by {{this.firstname}} {{this.lastname}}</p>
					<div class="link-nav">
						<span class="box">
							<router-link to="/main">Zark Academy</router-link>
							<i class="lnr lnr-arrow-right"></i>
                            <router-link to="">Blog</router-link>
						</span>
					</div>
				</div>
			</div>
		</div>
		<div class="rocket-img">
			<img src="../assets/img/rocket.png" alt="">
		</div>
	</section>
    <br><br>
    <div class="container emp-profile">
        <div class="row">
            <div class="col-md-4">
                <div class="profile-img">
                    <div v-if="this.imageUrl===''">
                        <img src="../assets/img/defaultuser.png" alt="../assets/img/defaultUser.png">
                    </div>
                    <div v-else>
                        <img :src="this.imageUrl" >
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="profile-head">
                            <h5>
                                {{this.firstname}} {{this.lastname}}
                            </h5>
                            <h6>
                                {{this.headline}}
                            </h6>
                            <p class="proile-rating">ABOUT ME: <span>{{this.about}}</span></p>
                </div>
            </div>
            <div class="col-md-2">
                <button class="profile-edit-btn" @click="gotoIndividualUserChat">Message</button>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4">
                <div class="profile-work">
                    <p>QUCK LINKS</p>
                </div>
            </div>
            <div class="col-md-8">
                <ul class="nav nav-tabs" id="myTab" role="tablist">
                    <li class="nav-item">
                        <a class="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">About</a>
                    </li>
                </ul>
                <br>
                <div class="tab-content profile-tab" id="myTabContent">
                    <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
                        <div class="row">
                            <div class="col-md-6">
                                <label>User Id</label>
                            </div>
                            <div class="col-md-6">
                                <p>{{this.id}}</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <label>First Name</label>
                            </div>
                            <div class="col-md-6">
                                <p>{{this.firstname}}</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <label>Last Name</label>
                            </div>
                            <div class="col-md-6">
                                <p>{{this.lastname}}</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <label>Info</label>
                            </div>
                            <div class="col-md-6">
                                <p>{{this.headline}}</p>
                            </div>
                        </div>
                        <br>
                        <div class="row sicons">
                            <div class="col-md-3">
                                <a :href="`http://www.facebook.com/${this.facebookUrl}`" target="_blank"><i class="fa fa-facebook-square"></i></a>
                            </div>
                            <div class="col-md-3">
                                <a :href="`http://www.twitter.com/${this.twitterUrl}`" target="_blank"><i class="fa fa-twitter-square"></i></a>
                            </div>
                            <div class="col-md-3">
                                <a :href="`http://www.linkedin.com/${this.linkedinUrl}`" target="_blank"><i class="fa fa-linkedin-square"></i></a>
                            </div>
                            <div class="col-md-3">
                                <a :href="`http://www.youtube.com/${this.youtubeUrl}`" target="_blank"><i class="fa fa-youtube-square"></i></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <hr>
        <div class="container">
            <div class="blogarea">
                <h2>Blog</h2>
                <br><br><br><br>
                <div class="feature-inner row">
                    <div class="col-lg-4 col-md-6"
                        v-for="(post, index) in posts"
                        v-bind:item="post"
                        v-bind:index="index"
                        v-bind:key="post.id"
                        v-on:click="gotoIndividualPost(post.id,post.userId)"
                    >
                        <div class="feature-item">
                        <div class="wow fadeIn" data-wow-duration="1s" data-wow-delay=".1s">
                            <img :src="post.imageUrl"  style="width:100%; height:250px">
                            <p>{{post.description}}</p>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>          
    </div>
  </div>
</template>

<script>
import PostService from '../PostService';
import firebase from 'firebase';
import "firebase/auth";
export default {
    name: 'UserBlog',
    data(){
        return {
            id: '',
            posts: [],
            firstname: '',
            lastname: '',
            headline: '',
            about: '',
            links: '',
            twitterUrl: '',
            facebookUrl: '',
            linkedinUrl: '',
            youtubeUrl: '',
            userId: '',
            imageUrl: '',
        }
    },
    async created(){
        this.getUserId();
        try{
        this.posts = await PostService.gettingUserPosts(this.$route.params.id);
        } catch(err){
        this.error=err.message;
        }
        console.log(this.posts)
    },
    methods: {
        async getUserId() {
            await firebase.auth().onAuthStateChanged(user => {
                this.id = user.uid;
            });
            try{
                var response = await PostService.userAccountInfo(this.$route.params.id);
                this.firstname=response.data.firstname;
                this.lastname=response.data.lastname;
                this.headline= response.data.headline;
                this.about= response.data.about;
                this.links= response.data.links;
                this.twitterUrl= response.data.twitterUrl;
                this.facebookUrl= response.data.facebookUrl;
                this.linkedinUrl= response.data.linkedinUrl;
                this.youtubeUrl= response.data.youtubeUrl;
                this.userId= response.data.userId;
                this.imageUrl= response.data.imageUrl;
            } catch(err){
                this.error=err.message;
            }
        },
        async gotoIndividualPost(postid,userid){
            console.log(postid,userid);
            this.$router.replace({ name: "IndividualPost",params: {userid: userid, postid: postid} });
        },
        async gotoIndividualUserChat(){
            this.$router.replace({ name: "IndividualUserChat",params: {id: this.$route.params.id} });
        } 
    }
};
</script>

<style scoped>
@import '../assets/login.css';
.error {
  color: red;
  font-size: 18px;
}

#formContent {
    padding:10px;
}

.userdetail {
    margin-top: 20px;
}

.userdetail h4 span {
    font-weight: 600;
}

.userdetail h4 {
    margin-bottom: 40px;
}
.blogarea{
    text-align: center;
}
.feature-item {
    cursor: pointer;
}
.primary-btn {
    border: none;
}
.emp-profile{
    padding: 3%;
    margin-top: 3%;
    margin-bottom: 3%;
    border-radius: 0.5rem;
    background: linear-gradient(to right, #57b0b0, #57b0b0);
}
.profile-img{
    text-align: center;
}
.profile-img img{
    width: 70%;
    height: 100%;
}

.profile-img .file input {
    position: absolute;
    opacity: 0;
    right: 0;
    top: 0;
}
.profile-head h5{
    color: #fff;
    font-weight: 700;
}
.profile-head h6{
    color: #000;
    font-weight: 800;
}
.profile-edit-btn{
    border: none;
    border-radius: 1.5rem;
    width: 70%;
    padding: 2%;
    font-weight: 600;
    color: #000;
    cursor: pointer;
    outline: none;
}
.proile-rating{
    font-size: 14px;
    font-weight: 800;
    color: #fff;
    margin-top: 5%;
}
.proile-rating span{
    color: #000;
    font-size: 15px;
    font-weight: 600;
}
.profile-head .nav-tabs{
    margin-bottom:5%;
}
.profile-head .nav-tabs .nav-link{
    font-weight:600;
    border: none;
}
.profile-head .nav-tabs .nav-link.active{
    border: none;
    border-bottom:2px solid #0062cc;
}
.profile-work{
    padding: 5%;
}
.profile-work p{
    font-size: 12px;
    color: #000;
    font-weight: 600;
    margin-top: 10%;
}
.profile-work a{
    text-decoration: none;
    color: #fff;
    font-weight: 600;
    font-size: 14px;
}
.profile-work ul{
    list-style: none;
}
.profile-tab label{
    font-weight: 600;
    color: #fff;
}
.profile-tab p{
    font-weight: 600;
    color: #000;
}
.sicons a{
    font-size: 50px;
    color: #000;
}
</style>